
import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const RollingRenewPage = lazy(() => import('./RollingRenewPage'));
const path = 'reports/rolling-renew';
const RollingRenewRoute: FuseRouteItemType = {
	path: path,
	element: <RollingRenewPage />,
	settings: {
		layout: {
			config: {
				navbar: {
					display: true
				},
				toolbar: {
					title: 'Rolling Renews',
					helpName: 'Rolling Renews'
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	}
};

export default RollingRenewRoute;
